export const prefixedT = (key, prefix = "WEB_SIMULATOR") => {
  const prefixedKey = `${prefix}.${key}`;
  return prefixedKey;
};